// @ts-strict-ignore
import { CompilerPartial } from '../trackers/base-tracker';

export const slotBiddersTrackingCompiler = async ({
	data,
	slot,
}: CompilerPartial): Promise<CompilerPartial> => {
	return {
		slot,
		data: {
			...data,
			bidder_won: slot.winningBidderDetails ? slot.winningBidderDetails.name : '',
			bidder_won_price: slot.winningBidderDetails ? slot.winningBidderDetails.price : '',
		},
	};
};
